window.$ = window.jQuery = require('jquery');

export default function() {
    $('.cms-banners').slick({
        infinite: true,
        swipeToSlide: true,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-banners.js